
import React, { Fragment } from 'react'
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';

import History from '@/Helpers/History';

import { usePlan } from '@/Hooks/UsePlan'
import { useProject } from '@/Hooks/UseProject';
import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation';

import './LeftTeamSelector.scss'

const LeftTeamSelector = () => {

  const { t } = useTranslation()

  const {
    tooManyTeams,
    showTooManyTeamsModal,
  } = usePlan()

  const { teams, teamSelected, selectTeam } = useTeams()
  const { project } = useProject()

  const handleSelectTeam = (team: any) => {

    if (tooManyTeams) {

      showTooManyTeamsModal(t('TEAMS:TooManyTeamsTitle'))

      return
    }

    selectTeam(team)

    History.replace(`/project/${project._id}/teams/${team._id}`)
  }

  if (!teams.length) return null

  return (
    <Fragment>
      <div className="d-none d-lg-block">
        <div className="left-team-selector">
          {teams.map((team: any) => (
            <button key={team._id}
              className={`team-list-item ${teamSelected?._id === team._id ? 'selected' : ''}`}
              onClick={() => handleSelectTeam(team)}
            >
              <span className='team-name'>
                {team.name}
              </span>
              <span className="team-badge">
                <span className="icon-grupo_equipo" style={{ fontSize: '1rem', verticalAlign: -2 }}></span>{' '}
                {team.users.length}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="d-flex flex-fill d-lg-none">
        <div className="team-selector-mobile-container">
          <DropdownButton
            className="team-selector-mobile"
            title={teamSelected?.name || ''}
          >
            {teams.map((team: any) => (
              <Dropdown.Item key={team._id}
                onClick={() => handleSelectTeam(team)}
                {...(teamSelected?._id === team._id ? { active: true } : {})}
              >
                <span className='team-name'>
                  {team.name}
                </span>
                <span className="team-badge">
                  <span className="icon-grupo_equipo" style={{ fontSize: '1rem', verticalAlign: -2 }}></span>{' '}
                  {team.users.length}
                </span>
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </div>
      </div>
    </Fragment>
  )
}

export default LeftTeamSelector
